var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("平台列表")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "平台ID", prop: "userId" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入平台ID", clearable: "" },
                      model: {
                        value: _vm.searchForm.id,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "id", $$v)
                        },
                        expression: "searchForm.id",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "平台名称", prop: "username" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入平台名称" },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户ID", prop: "userId" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入用户ID", clearable: "" },
                      model: {
                        value: _vm.searchForm.userId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "userId", $$v)
                        },
                        expression: "searchForm.userId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户昵称", prop: "username" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入用户昵称" },
                      model: {
                        value: _vm.searchForm.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "username", $$v)
                        },
                        expression: "searchForm.username",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号码", prop: "phone" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入手机号码" },
                      model: {
                        value: _vm.searchForm.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "phone", $$v)
                        },
                        expression: "searchForm.phone",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户等级", prop: "vipLevel" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择用户等级",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.vipLevel,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "vipLevel", $$v)
                          },
                          expression: "searchForm.vipLevel",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.platform_vip_level,
                        function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "平台类目", prop: "categoryIds" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.categoryList,
                        "show-all-levels": false,
                        props: {
                          multiple: true,
                          checkStrictly: true,
                          emitPath: false,
                        },
                        clearable: "",
                      },
                      on: { change: _vm.onChangeCategory },
                      model: {
                        value: _vm.searchForm.categoryIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "categoryIds", $$v)
                        },
                        expression: "searchForm.categoryIds",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "平台类型", prop: "type" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择平台类型", clearable: "" },
                        model: {
                          value: _vm.searchForm.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "type", $$v)
                          },
                          expression: "searchForm.type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "矩阵小程序", value: "0" },
                        }),
                        _c("el-option", {
                          attrs: { label: "投流小程序", value: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "上线时间", prop: "brandId" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                        clearable: false,
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.openTime,
                        callback: function ($$v) {
                          _vm.openTime = $$v
                        },
                        expression: "openTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "status" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择状态",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "status", $$v)
                          },
                          expression: "searchForm.status",
                        },
                      },
                      _vm._l(_vm.statuss, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.getList("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.getList("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticStyle: { height: "10px" } }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [
          _c("h3", [_vm._v("列表数据")]),
          _c(
            "div",
            [
              this.parArray.indexOf("platforms_resetConfigAll") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.refeshSetting },
                    },
                    [_vm._v("刷新配置")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.add("add")
                    },
                  },
                },
                [_vm._v("新增平台")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setting()
                    },
                  },
                },
                [_vm._v("平台设置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.deriveDeliver },
                },
                [_vm._v("批量导出")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.searchForm.pageNo,
                "page-size": _vm.searchForm.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.searchForm, "pageNo", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示信息",
            visible: _vm.isN,
            width: "643px",
            "append-to-body": true,
            "close-on-click-modal": false,
            "custom-class": "infoI",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isN = $event
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("div", [
              _c("i", {
                staticClass: "el-icon-warning",
                staticStyle: { "font-size": "22px", color: "#edb840" },
              }),
              _c("span", { staticStyle: { fontSize: "22px" } }, [
                _vm._v("提示信息"),
              ]),
            ]),
          ]),
          this.pIsInsideBuy == 0
            ? _c("div", [
                _vm._v(
                  "该平台确认是否开启【内购】价格？开启后，内部人员下单按内购价格下单购买！"
                ),
              ])
            : _vm._e(),
          this.pIsInsideBuy == 1
            ? _c("div", [
                _vm._v(
                  "该平台确认是否关闭【内购】价格？关闭后，所有用户按零售价格下单购买！"
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "end",
                "margin-top": "24px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "info-q",
                  on: {
                    click: function ($event) {
                      _vm.isN = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c("div", { staticClass: "info-s", on: { click: _vm.submitN } }, [
                _vm._v("确定"),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }